/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useRef, useState } from "react";
import {
  FaChartArea,
  FaChartLine,
  FaChartPie,
  FaChevronRight,
  FaUserCircle,
  FaUserFriends,
  FaUserGraduate,
  FaUserTie,
} from "react-icons/fa";

// api
import schoolApi from "../../api/School";
import activitiesApi from "../../api/Activities";

//css
import "./Dashboard.css";

//components
import Card from "../../components/card/Card";
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import ListTitleSubtitle from "../../components/lists/listTitleSubtitle/ListTitleSubtitle";
import Barchart from "../../components/chart/barchart/Barchart";
import DoughnutChart from "../../components/chart/doughnut/DoughnutChart";
import StatCard from "../../components/statcard/StatCard";
import AppCalendar from "../../components/calendar/AppCalendar";
import AppWrapper from "../../components/appWrapper/AppWrapper";

//data
import {
  empty,
  errorResponse,
  isArray,
  isObject,
  prepareResponseData,
} from "../../Utilities/utils";
import { AuthContext } from "../Root/ProtectedRoute";
import { Toast } from "primereact/toast";
import { useEffect } from "react";
import BoxLoading from "../../components/skeleton/BoxLoading";
import BarChartLoading from "../../components/skeleton/BarChartLoading";
import DonutChartLoading from "../../components/skeleton/DonutChartLoading";
import TableLoading from "../../components/skeleton/TableLoading";
import colors from "../../config/colors";
import EmptyListResponse from "../../components/emptyDiv/EmptyListResponse";
import ActivitiesList from "../../components/lists/activities/ActivitiesList";
import { NavLink, useNavigate } from "react-router-dom";
import { Avatar } from "primereact/avatar";

const Dashboard = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const [date, setDate] = useState(null);
  const [noOfStudentsInSchool, setNoOfStudentsInSchool] = useState(0);
  const [noOfSubjectsInSchool, setNoOfSubjectsInSchool] = useState(0);
  const [noOfStaffInSchool, setNoOfStaffInSchool] = useState(0);
  const [noOfClasses, setNoOfClasses] = useState(0);
  const [studentPerformance, setStudentPerformance] = useState(0);
  const [noOfStudentsGender, setNoOfStudentsGender] = useState(0);
  const [staffGender, setStaffGender] = useState(0);
  const [parentsCount, setParentsCount] = useState(0);
  const [activities, setActivities] = useState([]);
  const [isActivityLoading, setIsActivityLoading] = useState(false);
  const [
    staffStudentAttendancePercentCount,
    setStaffStudentAttendancePercentCount,
  ] = useState({
    studentPercentPresent: 0,
    staffPercentPresent: 0,
    staffPresent: 0,
    studentsPresent: 0,
  });
  const [recentlyRegisteredStudents, setRecentlyRegisteredStudent] = useState(
    []
  );
  const [recentlyRegisteredStaff, setRecentlyRegisteredStaff] = useState([]);
  const navigate = useNavigate();

  // stat status
  const [noOfStudentsLoading, setNoOfStudentsLoading] = useState(false);
  const [noOfSubjectsLoading, setNoOfSubjectsLoading] = useState(false);
  const [noOfStaffLoading, setNoOfStaffLoading] = useState(false);
  const [noOfClassesLoading, setNoOfClassesLoading] = useState(false);
  const [assessmentPerformanceLoading, setAssessmentPerformanceLoading] =
    useState(false);
  const [assessmentDataLoading, setAssessmentDataLoading] = useState(false);
  const [noOfStudentsByGenderLoading, setNoOfStudentsByGenderLoading] =
    useState(false);
  const [noOfStaffByGenderLoading, setNoOfStaffByGenderLoading] =
    useState(false);
  const [
    recentlyRegisteredStudentsLoading,
    setRecentlyRegisteredStudentsLoading,
  ] = useState(false);
  const [recentlyRegisteredStaffLoading, setRecentlyRegisteredStaffLoading] =
    useState(false);
  const [classTopPerformers, setClassTopPerformers] = useState({});
  const [parentsLoading, setParentsLoading] = useState(false);
  const [attendanceLoading, setAttendanceLoading] = useState(false);
  const [classTopPerformersLoading, setClassTopPerformersLoading] = useState(false);

  const [chartData, setChartData] = useState({
    labels: "",
    datasets: [
      {
        label: "Class Performance",
        data: 0,
        backgroundColor: colors.charcoal,
        borderRadius: 12,
      },
    ],
  });
  const toastTR = useRef(null);

  useEffect(() => {
    if (empty(user) || empty(user._id)) return;

    let isMounted = true;

    const loadDashboard = async () => {
      await Promise.all([
        getNumOfStudents(),
        getNoOfSubjects(),
        getNoOfStaff(),
        getNoOfClasses(),
        getStudentAssessmentPerformance(),
        getSchoolAssessmentsData(),
        getNoOfStudentsByGender(),
        getNoOfStaffByGender(),
        getRecentlyRegisteredStudents(),
        getRecentlyRegisteredStaff(),
        getParentsCount(),
        getStaffStudentAttendancePercentCount(),
        getActivities(),
        getClassTopPerformingStudents(),
      ]);
      if (!isMounted) return;
    };

    loadDashboard();

    return () => {
      console.log("mounted");
      isMounted = false;
    };
  }, [user?._id]);

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  }; 

  const getNumOfStudents = async () => {
    setNoOfStudentsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await schoolApi.getNumberOfStudentsInSchool(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setNoOfStudentsInSchool(0);
      }
      setNoOfStudentsInSchool(
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : 0
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setNoOfStudentsLoading(false);
    }
  };

  // function to get all activities
  const getActivities = async (limit = 12, list = true) => {
    try {
      if (!isActivityLoading && list) setIsActivityLoading(true);
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await activitiesApi.getActivities(
        schoolId,
        null,
        null,
        null,
        limit
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setActivities([]);
      } else {
        setActivities(
          isArray(response_data?.response) ? response_data.response : []
        );
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsActivityLoading(false);
    }
  };

  /**
   * Get Parents count
   * @returns
   */
  const getParentsCount = async () => {
    setParentsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await schoolApi.getParentsCount(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.success) {
        return setParentsCount(0);
      }
      setParentsCount(response_data?.response || 0);
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setParentsLoading(false);
    }
  };

  /**
   * Get staff and student attendance percentage count
   * @returns
   */
  const getStaffStudentAttendancePercentCount = async () => {
    setAttendanceLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await schoolApi.getStaffStudentAttendancePercentCount(
        schoolId
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data?.success) {
        return setStaffStudentAttendancePercentCount((prev) => ({ ...prev }));
      }
      setStaffStudentAttendancePercentCount((prev) => ({
        ...prev,
        studentPercentPresent:
          response_data?.response?.studentPercentPresent || 0,
        staffPercentPresent: response_data?.response?.staffPercentPresent || 0,
        studentsPresent: response_data?.response?.studentsPresent || 0,
        staffPresent: response_data?.response?.staffPresent || 0,
      }));
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setAttendanceLoading(false);
    }
  };

  /**
   * Get school assessment data
   * @returns
   */
  const getSchoolAssessmentsData = async () => {
    setAssessmentDataLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await schoolApi.getSchoolAssessmentsData(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return;
      }
      const _assessmentData = isArray(response_data?.response)
        ? response_data.response
        : [];
      setChartData({
        labels: _assessmentData.map((data) => {
          const classTitle =
            !empty(data) && !empty(data.title) ? data.title : "";
          return classTitle;
        }),
        datasets: [
          {
            label: "Class Performance",
            data: _assessmentData.map((data) => {
              const sum = !empty(data) && !empty(data.sum) ? data.sum : 0;
              return sum;
            }),
            backgroundColor: _assessmentData.map((data) => {
              const sum = !empty(data) && !empty(data.sum) ? data.sum : 0;
              let colorCode = colors.primary;
              if (sum < 50) {
                colorCode = colors.orange;
              }
              return colorCode;
            }),
            borderRadius: 12,
          },
        ],
      });
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setAssessmentDataLoading(false);
    }
  };

  /**
   * Get Number of Subjects
   * @returns
   */
  const getNoOfSubjects = async () => {
    setNoOfSubjectsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await schoolApi.getNumberOfSubjectsInSchool(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setNoOfSubjectsInSchool(0);
      }
      setNoOfSubjectsInSchool(
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : 0
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setNoOfSubjectsLoading(false);
    }
  };

  /**
   * Get no of students by gender
   */
  const getNoOfStudentsByGender = async () => {
    setNoOfStudentsByGenderLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await schoolApi.getNoOfSchoolStudentsByGender(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setNoOfStudentsGender(0);
      }
      setNoOfStudentsGender(
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : 0
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setNoOfStudentsByGenderLoading(false);
    }
  };

  /**
   * Get class top performing students
   * @returns
   */
  const getClassTopPerformingStudents = async () => {
    setClassTopPerformersLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await schoolApi.getClassTopPerformingStudents(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setClassTopPerformers({});
      }
      setClassTopPerformers(
        isObject(response_data.response) ? response_data.response : {}
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setClassTopPerformersLoading(false);
    }
  };

  /**
   * Get number of staff
   * @returns
   */
  const getNoOfStaff = async () => {
    setNoOfStaffLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await schoolApi.getNumberOfStaff(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setNoOfStaffInSchool([]);
      }
      setNoOfStaffInSchool(
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : 0
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setNoOfStaffLoading(false);
    }
  };

  const getNoOfClasses = async () => {
    setNoOfClassesLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await schoolApi.getNumberOfClasses(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setNoOfClasses(0);
      }
      setNoOfClasses(
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : 0
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setNoOfClassesLoading(false);
    }
  };

  const getStudentAssessmentPerformance = async () => {
    setAssessmentPerformanceLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await schoolApi.getStudentAssessmentPerformance(
        schoolId
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setStudentPerformance(0);
      }
      setStudentPerformance(
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : 0
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setAssessmentPerformanceLoading(false);
    }
  };

  const getNoOfStaffByGender = async () => {
    setNoOfStaffByGenderLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await schoolApi.getNoOfSchoolStaffByGender(schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setStaffGender(0);
      }
      setStaffGender(
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : 0
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setNoOfStaffByGenderLoading(false);
    }
  };

  const getRecentlyRegisteredStudents = async () => {
    setRecentlyRegisteredStudentsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await schoolApi.getRecentlyRegisteredStudents(
        schoolId,
        0,
        10,
        ""
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setRecentlyRegisteredStudent([]);
      }
      setRecentlyRegisteredStudent(
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : []
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setRecentlyRegisteredStudentsLoading(false);
    }
  };

  const getRecentlyRegisteredStaff = async () => {
    setRecentlyRegisteredStaffLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await schoolApi.getRecentlyRegisteredStaff(
        schoolId,
        0,
        10,
        ""
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return setRecentlyRegisteredStaff([]);
      }
      setRecentlyRegisteredStaff(
        !empty(response_data) && !empty(response_data.response)
          ? response_data.response
          : []
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setRecentlyRegisteredStaffLoading(false);
    }
  };

  /**
   * Date template
   * @param {*} date
   * @returns
   */
  const dateTemplate = (date) => {
    let validMonth = "";
    if (String(date?.month).length === 1 && date.month <= 8) {
      validMonth = String(date.month + 1).padStart(2, "0");
    } else {
      validMonth = date.month + 1;
    }

    const validDay = String(date.day).padStart(2, "0");

    const calendarDate = new Date(
      `${date.year}-${validMonth}-${validDay}T00:00:00.000Z`
    );
    const formattedCalendarDate = new Date(calendarDate).getTime();
    const today = new Date().getTime();

    let activityId = {};
    const _activities = isArray(activities) ? activities : [];
    const isFutureActivity = _activities.some((activity) => {
      const activityDate =
        new Date(activity?.startDate).getTime() || new Date().getTime();

      if (activityDate === formattedCalendarDate && activityDate > today) {
        activityId = activity?._id || "";
        return true;
      }
      return false;
    });

    // Apply styling for future activity dates
    if (isFutureActivity) {
      return (
        <span
          style={{
            backgroundColor: colors.primary,
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            fontWeight: "bold",
            color: colors.white,
          }}
          onClick={() => viewActivityDetails(activityId)}
        >
          {date.day}
        </span>
      );
    }

    // Default rendering for other dates
    return <span>{date.day}</span>;
  };

  const viewActivityDetails = (activityId) => {
    try {
      navigate(`/activity/${activityId}/update`);
    } catch (error) {
      responseDialog(
        "error",
        "Redirect Error",
        "Failed to redirect to activity details"
      );
    }
  };

  return (
    <>
      <AppWrapper {...props}>
        <main>
          {/* menu header */}
          <MainHeader title="Hello, Welcome Back!" leftIcon="&#128075; " />
          {/* end menu header */}
          <div className="mt-10 dashboard_container">
            {/* left box */}
            <div id="main_left_box">
              {/* stat box */}
              <div className="top_stat_box">
                <Card
                  children={
                    !noOfStudentsLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Number of Students"
                        entry={noOfStudentsInSchool}
                        icon={
                          <FaUserGraduate
                            size={14}
                            className="stat_card_icon"
                          />
                        }
                      />
                    ) : (
                      <BoxLoading /> 
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !noOfStaffLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Number of Staff"
                        entry={noOfStaffInSchool}
                        icon={
                          <FaUserTie size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !parentsLoading ? (<StatCard
                      underlineWidth={15}
                      bgColor={colors.primary}
                      title="Number of Parents"
                      entry={parentsCount}
                      icon={
                        <FaUserCircle size={14} className="stat_card_icon" />
                      }
                    />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !noOfSubjectsLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Number of Subjects"
                        entry={noOfSubjectsInSchool}
                        icon={
                          <FaUserTie size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
              </div>
              <div className="top_stat_box">
                <Card
                  children={
                    !noOfClassesLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Number of Classes"
                        entry={noOfClasses}
                        icon={
                          <FaUserFriends size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !assessmentPerformanceLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="General Assessment"
                        entry={studentPerformance + "%"}
                        icon={
                          <FaChartLine size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !attendanceLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor={colors.primary}
                        title="Students Attendance"
                        entry={`${
                          staffStudentAttendancePercentCount?.studentsPresent || 0
                        } (${
                          staffStudentAttendancePercentCount?.studentPercentPresent
                        }%)`}
                        icon={
                          <FaChartArea size={14} className="stat_card_icon" />
                        }
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    <StatCard
                      underlineWidth={15}
                      bgColor={colors.primary}
                      title="Staff Attendance"
                      entry={`${
                        staffStudentAttendancePercentCount?.staffPresent || 0
                      } (${
                        staffStudentAttendancePercentCount?.staffPercentPresent
                      }%)`}
                      icon={<FaChartPie size={14} className="stat_card_icon" />}
                    />
                  }
                  addStyle="card_adjust_stat"
                />
              </div>
              {/* stat header end */}

              {/* chart */}
              <div className="chart_box">
                <Card
                  children={
                    <>
                      <MainHeader title="Class Performance" />
                      {!assessmentDataLoading ? (
                        <Barchart data={chartData} />
                      ) : (
                        <BarChartLoading />
                      )}
                    </>
                  }
                  addStyle="barchart"
                />

                <div className="inner_chart_box">
                  <Card
                    children={
                      <>
                        <MainHeader title="Number of Students By Gender" />
                        {!noOfStudentsByGenderLoading ? (
                          <DoughnutChart
                            doughnutData={[
                              !empty(noOfStudentsGender) &&
                              !empty(noOfStudentsGender.male)
                                ? noOfStudentsGender.male
                                : 0,
                              !empty(noOfStudentsGender) &&
                              !empty(noOfStudentsGender.female)
                                ? noOfStudentsGender.female
                                : 0,
                            ]}
                          />
                        ) : (
                          <DonutChartLoading />
                        )}
                      </>
                    }
                    id="chart_box1"
                  />
                  <Card
                    children={
                      <>
                        <MainHeader title="Number of Staff By Gender" />
                        { !noOfStaffByGenderLoading ? (
                          <>
                            <DoughnutChart
                              doughnutData={[
                                !empty(staffGender) && !empty(staffGender.male)
                                  ? staffGender.male
                                  : 0,
                                !empty(staffGender) && !empty(staffGender.female)
                                  ? staffGender.female
                                  : 0,
                              ]}
                            />
                          </>
                        ) : (
                          <DonutChartLoading />
                        ) }
                      </>
                    }
                    id="chart_box1"
                  />
                </div>
                <div className="inner_chart_box">
                  <Card
                    children={
                      <>
                        <MainHeader title="Recently Registered Students" />
                        <div className="dashboard_school_list">
                          {!recentlyRegisteredStudentsLoading && !empty(recentlyRegisteredStudents) ? (
                            recentlyRegisteredStudents.map((student) => {
                              const firstName =
                                !empty(student) && !empty(student.firstName)
                                  ? student.firstName
                                  : "";
                              const lastName =
                                !empty(student) && !empty(student.lastName)
                                  ? student.lastName
                                  : "";
                              const middleName =
                                !empty(student) && !empty(student.middleName)
                                  ? student.middleName
                                  : "";
                              return (
                                <ListTitleSubtitle
                                  key={
                                    !empty(student) && !empty(student._id)
                                      ? student._id
                                      : ""
                                  }
                                  img={
                                    !empty(student) && !empty(student.avatar)
                                      ? student.avatar
                                      : ""
                                  }
                                  title={`${lastName} ${firstName} ${middleName}`}
                                  date={
                                    !empty(student) &&
                                    !empty(student.dateRegistered)
                                      ? student.dateRegistered
                                      : ""
                                  }
                                  subtitle={
                                    !empty(student) && !empty(student.class)
                                      ? student.class
                                      : ""
                                  }
                                  link={`/student/${
                                    !empty(student) && !empty(student._id)
                                      ? student._id
                                      : ""
                                  }/profile`}
                                />
                              );
                            })
                          ) : empty(recentlyRegisteredStudents) ? (
                            <EmptyListResponse />
                          ): (
                            <TableLoading rows={20} cols={1} header={false} />
                          )}
                        </div>
                      </>
                    }
                    id="chart_box2"
                  />
                  <Card
                    children={
                      <>
                        <MainHeader title="Recently Registered Staff" />
                        <div className="dashboard_school_list">
                          {!recentlyRegisteredStaffLoading &&
                          !empty(recentlyRegisteredStaff) ? (
                            recentlyRegisteredStaff.map((staff, index) => {
                              const firstName =
                                !empty(staff) && !empty(staff.firstName)
                                  ? staff.firstName
                                  : "";
                              const lastName =
                                !empty(staff) && !empty(staff.lastName)
                                  ? staff.lastName
                                  : "";
                              const middleName =
                                !empty(staff) && !empty(staff.middleName)
                                  ? staff.middleName
                                  : "";
                              return (
                                <ListTitleSubtitle
                                  key={
                                    !empty(staff) && !empty(staff._id)
                                      ? staff._id
                                      : ""
                                  }
                                  img={
                                    !empty(staff) && !empty(staff.avatar)
                                      ? staff.avatar
                                      : ""
                                  }
                                  title={`${lastName} ${firstName} ${middleName}`}
                                  date={
                                    !empty(staff) &&
                                    !empty(staff.dateRegistered)
                                      ? staff.dateRegistered
                                      : ""
                                  }
                                  subtitle={
                                    !empty(staff) && !empty(staff.email)
                                      ? staff.email
                                      : ""
                                  }
                                  link={`/staff/${
                                    !empty(staff) && !empty(staff._id)
                                      ? staff._id
                                      : ""
                                  }/profile`}
                                />
                              );
                            })
                          ) : empty(recentlyRegisteredStaff) ? (
                            <EmptyListResponse />
                          ) : (
                            <TableLoading rows={20} cols={1} header={false} />
                          )}
                        </div>
                      </>
                    }
                    id="chart_box2"
                  />
                </div>
              </div>
              {/* end chart */}

              {/*  */}
            </div>
            {/* end of left box */}

            {/* right box */}
            <div id="main_right_box">
              {/* calendar */}
              <div className="">
                {!isActivityLoading ? (
                  <AppCalendar
                    onChange={(e) => {
                      setDate(e.value);
                    }}
                    value={date}
                    dateTemplate={dateTemplate}
                  />
                ) : (
                  <BoxLoading />
                )}
              </div>

              {/* end of calendar */}
              <div className="main_right_boxes">
                {/* activities */}
                <Card
                  children={
                    <>
                      <MainHeader
                        link={`/list-activities`}
                        title="Activities"
                        iconRight={<FaChevronRight />}
                        fontSize={12}
                        buttonText="See All"
                        buttonHeight={22}
                        button
                      />
                      {!isActivityLoading &&
                      !empty(activities) &&
                      isArray(activities) ? (
                        activities.map((activity, index) => {
                          return (
                            <ActivitiesList
                              key={activity?._id || index}
                              data={activity}
                              link={`/activity/${activity?._id}/update`}
                            />
                          );
                        })
                      ) : empty(activities) ? (
                        <EmptyListResponse />
                      ) : (
                        <TableLoading rows={20} cols={1} header={false} />
                      )}
                    </>
                  }
                  addStyle="card_adjust"
                />
                {/* end of activities */}
                {/* Top class performing students */}
                <Card
                  children={
                    <>
                      <MainHeader title="Top Class Performing Students" />
                      {classTopPerformersLoading ? (
                          <TableLoading rows={20} cols={1} header={false} />
                        ) : !empty(classTopPerformers) ? (
                          Object.entries(classTopPerformers).map(([key, value], idx) => (
                            <div style={{ marginBottom: 20 }} key={idx}>
                              <div
                                style={{
                                  marginBottom: 5,
                                  fontSize: 14,
                                  color: colors.primary,
                                  fontWeight: "bold",
                                }}
                              >
                                {key}:
                              </div>

                              {isArray(value) &&
                                value.map((item, idxx) => (
                                  <NavLink
                                    to={`/student/${item?._id}/profile`}
                                    style={{
                                      textDecoration: "none",
                                      color: colors.mainSecondary,
                                    }}
                                    key={idxx}
                                  >
                                    <div
                                      style={{
                                        paddingTop: 10,
                                        paddingBottom: 10,
                                        paddingLeft: 5,
                                        paddingRight: 5,
                                        fontSize: 13,
                                        marginBottom: 5,
                                        display: "flex",
                                        flexDirection: "row",
                                        columnGap: 10,
                                        backgroundColor: colors.lightgray,
                                        borderRadius: 7,
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: 35,
                                          height: 35,
                                          borderRadius: 25,
                                          backgroundColor: colors.lightPrimary,
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                        }}
                                      >
                                        {item?.avatar ? (
                                          <Avatar image={item.avatar} />
                                        ) : (
                                          <i className="fa fa-user"></i>
                                        )}
                                      </div>

                                      <div style={{ color: colors.mainSecondary }}>
                                        <div style={{ marginBottom: 3, fontWeight: "bold" }}>
                                          {item.fullName}
                                        </div>
                                        <div>{item.average}%</div>
                                      </div>
                                    </div>
                                  </NavLink>
                                ))}
                            </div>
                          ))
                        ) : (
                          <EmptyListResponse />
                        )}
                      
                    </>
                  }
                  addStyle="card_adjust"
                />
                {/* end of top class performing students */}
              </div>
            </div>
          </div>
          {/* end of right box */}
        </main>
        <Toast ref={toastTR} position="bottom-left" />
      </AppWrapper>
    </>
  );
};

export default Dashboard;
